import { FormSubmissionData } from '../config/googleSheetsConfig';

class GoogleSheetsService {
  private auth: any = null;
  private sheets: any = null;

  constructor() {
    this.initializeAuth();
  }

  private async initializeAuth() {
    try {
      // For client-side, we'll use a different approach
      // You'll need to implement this based on your authentication method
    } catch (error) {
      // Silent error handling for production
    }
  }

  async submitToSheet(data: FormSubmissionData): Promise<boolean> {
    try {
      const response = await fetch('/api/submit-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      
      if (result.success) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  async submitToBackupSheet(data: FormSubmissionData): Promise<boolean> {
    // The backup submission is now handled by the backend API
    // This method is kept for compatibility but the backend handles both sheets
    return true;
  }
}

export const googleSheetsService = new GoogleSheetsService();
